<app-topbar></app-topbar>
<app-sidebar></app-sidebar>

<div class="app-content content">
  <div class="content-wrapper">
    <div class="content-header">
      <div class="page-head">
        <div>
          <h3 class="page-head__title">
            Transaction log - #{{ transaction?.transaction_ref }}
          </h3>
          <p class="page-head__sub">Transaction Details</p>
        </div>
        @if (this.details?.email === 'ayodeji@ionec.com') {
          <div class="page-head__tools">
            <button (click)="openModal()" class="btn btn-warning btn-round">
              Edit Transaction
              <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
            </button>
            <button (click)="retryTransaction($safeNavigationMigration(transaction?.transaction_ref))" class="btn btn-info btn-round"
              [disabled]="isRetrying">
              @if (!isRetrying) {
                <span>Retry transaction <i class="fa fa-refresh"></i></span>
              }
              @if (isRetrying) {
                <span><i class="fa fa-spinner fa-spin"></i> Retrying...</span>
              }
            </button>
          </div>
        }
      </div>
    </div>

    <div class="content-body">
      <!-- Revenue, Hit Rate & Deals -->
      <div class="row">
        <div class="col-12">
          <div class="rowMargin all-details">
            <div class="col-md-6">
              <div class="card-header border-right row">
                <div class="row">
                  <div class="status">
                    <span class="status-badge status-{{
                        transaction?.status
                      }}" [@statusChange]="$safeNavigationMigration(transaction?.status)">
                      {{ $safeNavigationMigration(transaction?.status) | uppercase }}
                    </span>
                    <span class="message">{{ transaction?.message }}</span>
                  </div>
                  <div class="col-md-6 heading">Reference ID</div>
                  <div class="col-md-6 detail">
                    #{{ transaction?.transaction_ref }}
                  </div>

                  <div class="col-md-6 heading">Agent</div>
                  <div class="col-md-6 details">
                    @if (transaction && transaction?.agent) {
                      <a [routerLink]="['/agent', $safeNavigationMigration(transaction?.agent?.slug)]">{{
                        transaction?.agent?.name
                      }}</a>
                    }
                    @if (!transaction) {
                      <a>{{ transaction?.agent?.name }}</a>
                    }
                  </div>

                  <div class="col-md-6 heading">Amount</div>
                  <div class="col-md-6 details bold">
                    NGN {{ $safeNavigationMigration(transaction?.payout_amount) | number }}
                  </div>

                  <div class="col-md-6 heading">Amount Sent</div>
                  <div class="col-md-6 details">
                    NGN {{ $safeNavigationMigration(transaction?.amount_sent) | number }}
                  </div>

                  <div class="col-md-6 heading">IMTO Balance After</div>
                  <div class="col-md-6 details">
                    @if (
                      $safeNavigationMigration(transaction?.imto_balance_after) !== null &&
                      $safeNavigationMigration(transaction?.imto_balance_after) !== undefined
                      ) {
                      NGN {{ $safeNavigationMigration(transaction?.imto_balance_after) | number }}
                    }
                    @if (
                      $safeNavigationMigration(transaction?.imto_balance_after) === null ||
                      $safeNavigationMigration(transaction?.imto_balance_after) === undefined
                      ) {
                      <span
                        class="text-muted"
                        >
                        Not debited (no wallet effect)
                      </span>
                    }
                  </div>

                  <div class="col-md-6 heading">Payment Method</div>
                  <div class="col-md-6 details">
                    {{ transaction?.mode_of_payment }}
                  </div>

                  <div class="col-md-6 heading">Time</div>
                  <div class="col-md-6 details">
                    {{ $safeNavigationMigration(transaction?.created_at) | date : "HH:mm" }}
                  </div>

                  <div class="col-md-6 heading">Date</div>
                  <div class="col-md-6 details">
                    {{ $safeNavigationMigration(transaction?.created_at) | date }}
                  </div>
                </div>
                <div class="center block col-md-12 pt-10 pb-10">History</div>

                @for (event of transaction?.transaction_events?.events; track event) {
                  <div class="row" style="width: 100%">
                    <div class="col-md-6 heading" style="width: 40%">
                    <span class="label-status {{
                        event?.status?.status || event?.status || 'processing'
                      }}"></span>
                      <span class="heading">{{ event?.action }}</span>
                    </div>
                    <div class="col-md-6 details">
                      {{ $safeNavigationMigration(event?.date?.date) | date : "HH:mm:ss dd LLLL, y" }}
                    </div>
                  </div>
                }
              </div>
            </div>
            <div class="col-md-6">
              <div class="card-header border-right no-border row">
                <div class="center block col-md-12 pt-10 pb-10">Sender</div>
                <div class="col-md-5 heading">Name</div>
                <div class="col-md-7 detail" style="text-transform: capitalize">
                  {{ transaction?.sender_fullname }}
                </div>

                <div class="col-md-5 heading">Email</div>
                <div class="col-md-7 details">
                  {{ transaction?.sender_email }}
                </div>

                <div class="col-md-5 heading">Telephone</div>
                <div class="col-md-7 details">
                  {{ transaction?.sender_mobile_number }}
                </div>

                <div class="col-md-5 heading pb-30">Location</div>
                <div class="col-md-7 details pb-30">
                  {{ transaction?.sender_city }},
                  {{ transaction?.sender_country }}
                </div>

                <div class="col-md-5 heading">Purpose of Transaction</div>
                <div class="col-md-7 details">
                  {{ transaction?.purpose_of_transaction }}
                </div>

                <div class="center block col-md-12 pt-30 pb-10">
                  Beneficiary
                </div>

                <div class="col-md-5 heading">Name</div>
                <div class="col-md-7 detail">
                  {{ transaction?.beneficiary_fullname }}
                </div>

                <div class="col-md-5 heading">Email</div>
                <div class="col-md-7 details">
                  {{ transaction?.beneficiary_email }}
                </div>

                <div class="col-md-5 heading">Telephone</div>
                <div class="col-md-7 details">
                  {{ transaction?.beneficiary_mobile_number }}
                </div>

                <div class="col-md-5 heading">Location</div>
                <div class="col-md-7 details">
                  {{ transaction?.beneficiary_city }},
                  {{ transaction?.beneficiary_country }}
                </div>

                <div class="col-md-5 heading">Bank Name</div>
                <div class="col-md-7 details">
                  {{ transaction?.beneficiary_bank_name }}
                </div>

                <div class="col-md-5 heading">Account Name</div>
                <div class="col-md-7 details">
                  {{ transaction?.beneficiary_bank_account_name }}
                </div>

                <div class="col-md-5 heading">Account Number</div>
                <div class="col-md-7 details">
                  {{ transaction?.beneficiary_bank_account_number }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-bottombar></app-bottombar>

<!-- ANGULAR-ONLY MODAL -->
@if (showModal) {
  <div class="modal-backdrop">
    <div class="modal-box">
      <h3>Edit Beneficiary Details</h3>
      <label for="beneficiary-bank-name">Bank Name</label>
      <input id="beneficiary-bank-name" type="text" [(ngModel)]="editData.beneficiary_bank_name" />
      <label for="beneficiary-account-name">Account Name</label>
      <input id="beneficiary-account-name" type="text" [(ngModel)]="editData.beneficiary_bank_account_name" />
      <label for="beneficiary-account-number">Account Number</label>
      <input id="beneficiary-account-number" type="text" [(ngModel)]="editData.beneficiary_bank_account_number" />
      <div class="actions">
        <button class="btn cancel" (click)="closeModal()">Cancel</button>
        <button class="btn save" (click)="submitEdit()">Save</button>
      </div>
    </div>
  </div>
}